<!--
  Invite History tab — the inline history block moved out of the old Textinvites.vue,
  shaped like EmailInvites23/InviteHistory.vue (June '26).
-->
<template>
  <div>
    <div class="vx-row" id="inviterecord">
      <div class="vx-col w-full mb-base flex" v-if="inviteHistory.length !== 0">
        <vx-card class="pb-5" title="Text Invite History" v-if="inviteHistory.length > 0">
          <vs-table pagination max-items="20" search :data="inviteHistory" stripe >
            <template slot="thead">
              <vs-th>Date & Time Sent</vs-th>
              <vs-th>To Number</vs-th>
            </template>
            <template slot-scope="{data}">
              <vs-tr :key="indextr" v-for="(tr, indextr) in data">
                <vs-td :data="data[indextr].dateSent">
                  {{ formatTimeStamp(data[indextr].dateSent) }}
                </vs-td>
                <vs-td :data="data[indextr].to">
                  {{ data[indextr].to}}
                </vs-td>
              </vs-tr>
            </template>
          </vs-table>
          <div clas="w-full" v-if="hasMoreInvites">
            <vs-button :disabled="invitesLoading" class="block mt-10 mx-auto" @click="getInvites(false)" type="border">Load more</vs-button>
          </div>
        </vx-card>
      </div>
      <div class="vx-col w-full mb-base flex" v-else>No invites sent yet.</div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      hasMoreInvites: false,
      invitesLoading: false
    }
  },
  computed: {
    inviteHistory() {
      return this.$store.state.dash.viewData.textInviteRecord
    }
  },
  methods: {
    getInvites(initial = false) {

      this.invitesLoading = true

      let startAfter = false
      if (!initial) {
        //pass the id of last record:
        startAfter = this.inviteHistory[this.inviteHistory.length - 1].id
      }

      console.log('getting more..')
      console.log(startAfter)

      this.$store.dispatch('dash/SYNC_INVITE_SENT_HISTORY', {
          type: 'text',
          startAfter
        }).then((hasMore) => {
          this.hasMoreInvites = hasMore
          this.invitesLoading = false
       }).catch((e) => {
          this.invitesLoading = false
       })

    }
  },
  mounted() {
    this.getInvites(true)
  }
}
</script>
